<section class="reward-listing">
  <div class="container">
    <div class="row">
      <div class="col-md-4 title text-right" *ngIf="isPhone">
        <span class="cancel-txt" (click)="closeSheet()">CANCEL</span>
      </div>
      <div class="col-md-8 title">
        <h2>Rewards & Offers for you </h2>
      </div>
      <div class="col-md-4 title text-right" *ngIf="!isPhone">
        <span class="cancel-txt" (click)="closeSheet()">CANCEL</span>
      </div>
    </div>
  </div>
  <div class="container">
    <mat-tab-group mat-align-tabs="start" disableRipple>
      <mat-tab>
        <ng-template mat-tab-label>
          Applicable Offers
        </ng-template>
        <section class="coupon-code-section">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="box">
                  <input type="text" [(ngModel)]="applyCouponVal" class="custom-coupon-box input-text"
                    placeholder="Enter coupon code" minLength="1" maxlength="50">
                  <button type="button" class="text-btn" (click)="applyCoupon()">APPLY</button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="recommends-section light-yellow-panel">
          <div class="container">
            <div class="row">
              <div class="col-md-6  col-sm-12">
              </div>
              <div class="col-md-6  col-sm-12 text-right">
              </div>
              <div class="col-12 text-center no-offers" *ngIf="noAOffers">
                <img src="assets/images/No Offers found.svg" alt="no-store">
                <h6>No Offers Found!</h6>
              </div>
              <div class="col" *ngIf="!noAOffers">
                <swiper [config]="config" #usefulSwiper [autoHeight]="true" (swiper)="setControlledSwiper($event)"
                  [navigation]="{}" [pagination]="{ clickable: true }">
                  <ng-template swiperSlide *ngFor="let data of applicableOffersArray;let i = index">
                    <div class="card">
                      <div class="card-cut">
                        <div class="top-card" [ngClass]="{'full-width': data['showDetails']}">
                          <div class="card-horizontal">
                            <div class="card-body">
                              <h3 class="card-title">{{data.promotionName}}</h3>
                              <p>{{data?.promotionDescription}}
                              </p>
                              <h6 *ngIf="!data['showDetails']">
                                EXPIRES ON {{data?.expiryDate | date: 'dd/MM/yyyy'}}
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="bottom-card">
                        <div class="footer2">
                          <div>
                            <button *ngIf="!data['isApplied']" type="button" (click)="useReward(data,i)"
                              class="custom-btn btn-green btn-sm-rounded">Apply
                            </button>
                            <button *ngIf="data['isApplied']" type="button" (click)="removeCoupon(data)"
                              class="custom-btn btn-green btn-sm-rounded">
                              Applied
                              <img src="assets/icon/white_close.svg" alt="remove">
                            </button>
                          </div>
                          <div class="detail">
                            <h3 (click)="detailCoupon(data)">
                              <a>{{data['showDetails'] ? 'Done' : 'Details'}}</a>
                            </h3>
                          </div>
                        </div>
                      </div>
                      <span class="coffee-pic" *ngIf="!data['showDetails']">
                        <img src="assets/icon/Mask Group.svg" alt="coffe">
                      </span>
                    </div>
                    <div class="radio-btn" *ngIf="showEligibleProducts && i == itemIndex">
                      <p *ngFor="let product of data?.items">
                        <mat-radio-button (change)="selectedOffer(data,product.itemId)">{{product.itemName}}
                        </mat-radio-button>
                      </p>
                    </div>
                  </ng-template>
                </swiper>
              </div>
            </div>
          </div>
        </section>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          Other Offers
        </ng-template>
        <section class="coupon-code-section">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="box">
                  <input type="text" [(ngModel)]="applyCouponVal" class="custom-coupon-box input-text"
                    placeholder="Enter coupon code" minLength="1" maxlength="50">
                  <button type="button" class="text-btn" (click)="applyCoupon()">APPLY</button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="recommends-section light-yellow-panel">
          <div class="container">
            <div class="row">
              <div class="col-12 text-center no-offers" *ngIf="noNAOffers">
                <img src="assets/images/No Offers found.svg" alt="no-store">
                <h6>No Offers Found!</h6>
              </div>
              <div class="col" *ngIf="!noNAOffers">
                <swiper [config]="config1" #usefulSwiper [autoHeight]="true" (swiper)="setControlledSwiper1($event)"
                  [navigation]="{}" [pagination]="{ clickable: true }">
                  <ng-template swiperSlide *ngFor="let data of nonApplicableOffersArray;let i = index">
                    <div class="card">
                      <div class="card-cut">
                        <div class="top-card" [ngClass]="{'full-width': rewardText == 'Done'}">
                          <div class="card-horizontal">
                            <div class="card-body">
                              <h3 class="card-title">{{data.title}}</h3>
                              <p>{{data?.content | textLimit:wordLimit}}
                              </p>
                              <h6 *ngIf="rewardText == 'Details'">
                                EXPIRES ON {{data?.endDate | date: 'dd/MM/yyyy'}}
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="bottom-card">
                        <div class="footer2">
                          <div>
                            <button type="button" [disabled]="true" class="custom-btn btn-green btn-sm-rounded">Use
                              Offer</button>
                          </div>
                          <div class="detail">
                            <h3 (click)="detail(i)"><a>{{rewardText}}</a></h3>
                          </div>
                        </div>
                      </div>
                      <span class="coffee-pic" *ngIf="rewardText == 'Details'">
                        <img src="assets/icon/Mask Group.svg" alt="coffe">
                      </span>
                    </div>
                  </ng-template>
                </swiper>
              </div>
            </div>
          </div>
        </section>
      </mat-tab>
    </mat-tab-group>
  </div>
</section>
